/* eslint-disable jsx-a11y/anchor-is-valid */
import { useTranslation } from 'react-i18next';
import { IoEarthSharp } from 'react-icons/io5';
import Flag from 'react-flagkit';
import { useState } from 'react';
import OutsideClickHandler from 'react-outside-click-handler';

const lngs = {
  en: { nativeName: 'English', flag: 'GB' },
  de: { nativeName: 'Deutsch', flag: 'DE' },
  fr: { nativeName: 'Français', flag: 'FR' },
  null: { nativeName: 'None', flag: 'https://em-content.zobj.net/source/twitter/376/prohibited_1f6ab.png' }, // use this for testing fallback and seeing i18n keys + keeping the emoji for one
};

function LanguageSelector() {
  const { i18n } = useTranslation();
  const [showMenu, setShowMenu] = useState(false);
  return (
    <OutsideClickHandler
      onOutsideClick={() => {
        setShowMenu(false);
      }}
    >
      <div className="relative inline-block text-left md:mt-0 ">
        <div className='flex items-center'>
          <button onClick={() => setShowMenu(!showMenu)} type="button" className="inline-flex justify-center w-full px-4 py-2 font-medium text-old-sentric-dark-gray focus:outline-none" id="menu-button" aria-expanded="true" aria-haspopup="true">
            <IoEarthSharp size={20} />
            <svg className="-mr-1 ml-2 h-6 w-6 text-old-sentric-light-gray" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
              <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
            </svg>
          </button>
        </div>
        {showMenu
    && (
    <div className="origin-top-right absolute right-0 mt-2 w-44 h-fit overflow-hidden rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none" role="menu" aria-orientation="vertical" aria-labelledby="menu-button" tabIndex="-1">
      <div>
        <div role="menuitem" tabIndex="-1">
          {Object.keys(lngs).map((lng) => <button className={`${lngs[lng].nativeName === 'None' ? '' : 'border-b'} hover:bg-gray-50 ${i18n.resolvedLanguage === lng ? 'bg-gray-50' : ''} text-gray-700 flex items-start gap-2 w-full text-left px-4 py-2 text-sm`} type="submit" role="menuitem" key={lng} onClick={() => i18n.changeLanguage(lng)} disabled={i18n.resolvedLanguage === lng}>  {lngs[lng].nativeName === 'None' ? <img src={lngs[lng].flag} alt={`${lngs[lng].nativeName} flag.`} className='w-5'/> : <Flag country={lngs[lng].flag} />} {lngs[lng].nativeName}</button>)}
        </div>
      </div>
    </div>
    )}
      </div>
    </OutsideClickHandler>
  );
}

export default LanguageSelector;
